import { Autocomplete, TextField } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ClassificationChip } from "./classification-chip"

const CLASSIFICATIONS = ["Red", "Pink", "Amber", "Green"]

export function ConditionValueClassification({ value, onChange }) {
    const selected = Array.isArray(value) ? value : value ? [value] : []

    return (
        <Autocomplete
            multiple
            options={CLASSIFICATIONS}
            value={selected}
            onChange={handleChange}
            renderTags={renderTags}
            renderInput={(params) => <TextField {...params} placeholder="Select classifications..." />}
        />
    )

    function handleChange(_, newValue) {
        onChange(newValue)
    }

    function renderTags(tagValue, getTagProps) {
        return <Repeat list={tagValue} item={<ClassificationChip getTagProps={getTagProps} />} />
    }
}
